import React, { FC, memo } from 'react';
import LegalText from '../LegalText';
import Logo from '../Logo';
import * as styles from './styles';

export interface FooterProps {
  legalText?: string;
}

const Footer: FC<FooterProps> = memo(({ legalText }) => (
  <footer className={styles.footer} aria-label="footer">
    {legalText && <LegalText>{legalText}</LegalText>}
    <Logo />
  </footer>
));

export default Footer;
